// components/GallerySection.jsx
import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import Image9 from "../../Assets/photo_2025-05-06_09-54-11.jpg?format=webp";
import Image10 from "../../Assets/WhatsApp Image 2025-05-06 at 3.13.23 PM.jpeg?format=webp";
import Image11 from "../../Assets/WhatsApp Image 2025-05-06 at 3.13.24 PM.jpeg?format=webp";
// import Image12 from "../../Assets/safe-mining-practice.webp";
import Image13 from "../../Assets/6a4c06d9-b7ea-44bd-a4de-5bdb1792a67f_w1200_h630.jpg?format=webp";
import Image14 from "../../Assets/images.jpg?format=webp";
import Image15 from "../../Assets/744620357c674a4c9f244da83e1bd4e3.jpg?format=webp";

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const galleryImages = [
  { id: 1, src: Image9, alt: "Panjshir Mining Operation 1" },
  { id: 2, src: Image10, alt: "Panjshir Mining Operation 2" },
  { id: 3, src: Image11, alt: "Panjshir Mining Operation 3" },
//   { id: 4, src: Image12, alt: "Panjshir Mining Operation 4" },
  { id: 5, src: Image13, alt: "Panjshir Mining Operation 5" },
  { id: 6, src: Image14, alt: "Panjshir Mining Operation 6" },
  { id: 7, src: Image15, alt: "Panjshir Mining Operation 7" },
];

export default function GallerySection() {
  const galleryRef = useRef(null);
  const galleryInView = useInView(galleryRef, { once: true, amount: 0.3 });

  return (
    <section id="gallery" className="py-24 px-4 sm:px-6 bg-gray-100">
      <motion.div
        ref={galleryRef}
        initial="hidden"
        animate={galleryInView ? "visible" : "hidden"}
        variants={fadeIn}
        className="container mx-auto px-4 sm:px-6 max-w-7xl"
      >
        <div className="text-center mb-16">
          <motion.div
            variants={fadeIn}
            className="inline-block px-4 py-1 bg-emerald-50 rounded-full text-emerald-800 font-sans text-sm tracking-wider uppercase mb-4"
          >
            Our Operations
          </motion.div>
          <motion.h2 variants={fadeIn} className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            Dubai Panjshir EmeraldVault Mining Gallery
          </motion.h2>
          <motion.p variants={fadeIn} className="max-w-2xl mx-auto text-gray-600 text-lg">
            Witness our Panjshir emerald mining operations, showcasing the valley’s rugged beauty and our careful processes that drive value for stakeholders.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((item) => (
            <motion.div
              key={item.id}
              className="relative overflow-hidden rounded-xl shadow-lg group"
              initial={{ opacity: 0, y: 50 }}
              animate={galleryInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
              transition={{ duration: 0.5, delay: item.id * 0.1 }}
            >
              <img
                src={item.src}
                alt={item.alt}
                className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="text-xl font-bold text-white mb-2">Panjshir Operation {item.id}</h3>
                <p className="text-emerald-100">Highlighting our work in the Panjshir Valley</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-11 px-8 bg-emerald-600 hover:bg-emerald-700 text-white shadow-lg shadow-emerald-700/20">
            View Full Gallery
          </button>
        </div>
      </motion.div>
    </section>
  );
}